module.exports = __webpack_public_path__ + "img/service.1305981.png";